import React from "react";
import portfolio from "../../assets/images/svg/portfolio.svg";
import SummaryStatusBar from "../SummaryStatusBar/SummaryStatusBar";
import FinancialValueContainer from "../FinancialValueContainer/FinancialValueContainer";
import ExtractBar from "../ExtractBar/ExtractBar";
import QuickViews from "../../components/QuickViews/QuickViews";
import AccordionTable from "../AccordionTable/AccordionTable";
import { observer } from "mobx-react";
import {
  downloadPDFFile,
  exportExcel,
  getAsOfDate,
  getCurrentDate,
  getExcelNumData2,
  getLimitPer,
  getPrintDate,
  getReportDetails,
  isFinancialAssetTabDataFailed,
  //printDocument,
} from "../../utils/functions";

//import PdfTable from "../PdfTable/PdfTable";
import UserStore from "../../store/UserStore";
import {
  errorText,
  familyViewTabs,
  financialAssetClassSheetName,
  financialExcelClms,
} from "../../utils/constants";
import { useState } from "react";
import { useEffect } from "react";
import NoDataFinancialAssets from "./NoDataFinancialAssets";
import AssetSummaryError from "./AssetSummaryError";

const ListItem = ({ isActive, className, onClick, tabsData }) => {
  return (
    <li
      className={isActive ? "is-active" : "portfolio_tabs_btn_animation"}
      onClick={onClick}
    >
      <button className={`port_tab_bton ${className}`}>
        <img
          className={isActive ? "selected_tab" : ""}
          src={
            isActive
              ? tabsData?.img?.selectedImg
              : tabsData?.img?.notSelectedImg
          }
          alt={tabsData.name}
        />
      </button>
    </li>
  );
};

const FinancialAssetSummary = observer(
  ({ isOffshore, title, summarytitle, dataPoint, noDataMessage }) => {
    const [selectedTab, setSelectedTab] = useState(familyViewTabs[0]);
    const [excelPdfData, setExcelPdfData] = useState([]);

    const allocationArray = UserStore[dataPoint]?.allocationSummary;

    const pdfTableId = "assetclasspdf";

    // columns for pdf table
    const pdfTableColumns = [
      { label: "Asset Class", key: "asset_class" }, // Top level data
      { label: "Allocation(%)", key: "allocation" },
      {
        label: "Current Value",
        key: "curr_value",
      },
      { label: "Inv Value", key: "inv_value" }, // Top level data
      { label: "Int/Div", key: "int_div" },
      { label: "Unrealised Gain", key: "unrealised_gain" }, // Top level data
      { label: "Unrealised(%)", key: "unrealised_percentage" },
      { label: "Realised Gain", key: "realised_gain" },
      { label: "IRR(%)", key: "irr" },
    ];

    const getPortfolioReportName = () => {
      const famName =
        UserStore.getData === "fam"
          ? UserStore.userData?.family_name
          : UserStore.userData?.full_name;
      return `Portfolio Summary - ${famName}`;
    };

    const getReportHeader = () => {
      return `${financialAssetClassSheetName} - INR`;
    };

    // const handlePdf = () => {
    //   printDocument(pdfTableId, {
    //     width: 650,
    //     height: 600,
    //     name: getPortfolioReportName(),
    //   });
    // };

    const isDataPresent = () => {
      const dataCheck = UserStore[dataPoint]?.clientPortfolioReturn;

      if (
        (dataCheck?.current_value?.value &&
          Number(dataCheck?.current_value?.value) !== 0) ||
        (dataCheck?.invested_value?.value &&
          Number(dataCheck?.invested_value?.value) !== 0) ||
        (dataCheck?.unrealised_gain?.amount.value &&
          Number(dataCheck?.unrealised_gain?.amount.value) !== 0) ||
        (dataCheck?.realised_gain?.amount.value &&
          Number(dataCheck?.realised_gain?.amount.value) !== 0) ||
        (dataCheck?.total_returns?.value &&
          Number(dataCheck?.total_returns?.value) !== 0)
      ) {
        return true;
      }
    };

    useEffect(() => {
      let modifiedExcelPdfData = [];
      let excelData = [];
      const tabId = selectedTab.id;

      if (UserStore.isInfinity === "0") {
        if (tabId === 0) {
          excelData = UserStore.excelAssetClassesData;
        } else {
          excelData = UserStore.excelAssetDataFamily;
        }
      } else {
        excelData = UserStore.excelAssetClassesDataInfinity;
      }

      const getExcelClms = (value) => {
        return getExcelNumData2(value, false, 2);
      };

      excelData?.forEach((assetClass) => {
        modifiedExcelPdfData.push({ ...assetClass, primary: true });
        assetClass.instrumentVehiclesList.forEach((subAssetClass) => {
          let subAssetObj = {
            asset_class: subAssetClass.assetClass.name,
            allocation: getLimitPer(subAssetClass.allocation_percentage),
            curr_value:
              getExcelClms(
                subAssetClass.investmentreturn.current_value.actual_value,
              ) || "-",
            inv_value:
              getExcelClms(
                subAssetClass.investmentreturn.invested_value.actual_value,
              ) || "-",
            int_div: getExcelClms(
              subAssetClass.investmentreturn.int_div.amount.actual_value,
            ),
            unrealised_gain:
              getExcelClms(
                subAssetClass.investmentreturn.unrealised_gain.amount
                  .actual_value,
              ) || "-",
            unrealised_percentage:
              getLimitPer(
                subAssetClass.investmentreturn.unrealised_gain.percentage,
              ) || "-",
            realised_gain:
              getExcelClms(
                subAssetClass.investmentreturn.realised_gain.amount
                  .actual_value,
              ) || "-",
            irr: getLimitPer(subAssetClass.investmentreturn.irr),
          };
          modifiedExcelPdfData.push({ ...subAssetObj });
        });
      });

      setExcelPdfData(modifiedExcelPdfData);
    }, [
      selectedTab,
      UserStore.excelAssetClassesData,
      UserStore.excelAssetClassesDataInfinity,
      UserStore.excelAssetDataFamily,
      // UserStore.offshoreData.downloadFileData,
      // UserStore.offshoreData.downloadFamilyViewFileData,
    ]);

    return (
      <>
        <div className="financial_outside">
          {UserStore.financialApiStatus.familyPortfolioReturn === "failure" ? (
            <AssetSummaryError
              className={"error_screen_asset_class"}
              alternateText={"No Financial Assets"}
              message={errorText}
            />
          ) : isDataPresent() ? (
            <div className="financial_inside_main">
              <div className="finance_head_wrapper">
                <h2 className="finance_head">{title}</h2>
              </div>

              <div className="financial_data_container">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "20px",
                    alignItems: "end",
                  }}
                >
                  <FinancialValueContainer dataPoint={dataPoint} />
                </div>
                {isFinancialAssetTabDataFailed({
                  apiList: UserStore.financialApiStatus,
                }) ? (
                  <AssetSummaryError
                    className={"error_screen_financial_asset_class"}
                    alternateText={"No Financial Assets"}
                    message={errorText}
                  />
                ) : UserStore[dataPoint]?.clientAssetClass?.length ? (
                  <>
                    {" "}
                    <div className="summary_outside family_view_tab">
                      <h2 className="title">
                        {selectedTab.id === 0 ? summarytitle : ""}{" "}
                      </h2>
                      <div className="tab_container">
                        <div className="tabs_part">
                          <div className="tabs ">
                            <ul>
                              {familyViewTabs.map((tabsData, index) =>
                                UserStore.getData === "fam" ? (
                                  <ListItem
                                    key={tabsData.name}
                                    isActive={selectedTab.id === tabsData.id}
                                    className={""}
                                    onClick={() => setSelectedTab(tabsData)}
                                    tabsData={tabsData}
                                  />
                                ) : (
                                  <ListItem
                                    key={tabsData.name}
                                    isActive={selectedTab.id === tabsData.id}
                                    className={"notClickable"}
                                    onClick={() => {}}
                                    tabsData={tabsData}
                                  />
                                ),
                              )}
                            </ul>
                          </div>
                        </div>
                      </div>
                      {excelPdfData && (
                        <ExtractBar
                          extractExcel={() => {
                            const columns = financialExcelClms;
                            exportExcel({
                              sheetname: getReportHeader(),
                              columns,
                              data: excelPdfData,
                              reportDetails: {
                                ...getReportDetails(
                                  UserStore?.exportDetails,
                                  UserStore.userData,
                                  UserStore.getData === "fam",
                                ),
                                date: getPrintDate(
                                  getAsOfDate(
                                    UserStore[dataPoint]?.clientPortfolioReturn
                                      ?.as_of_date,
                                  ),
                                ),
                              },
                              exportFrom: "portfolioPage1",
                              excelName: `${getPortfolioReportName()} - ${getCurrentDate()}`,
                              customSheetName: financialAssetClassSheetName,
                            });
                          }}
                          extractPdf={() => {
                            // handlePdf();
                            // return;

                            return downloadPDFFile({
                              headerName: getReportHeader(),
                              fileId: pdfTableId,
                              name: getPortfolioReportName(),
                              columns: pdfTableColumns,
                              data: excelPdfData || [],
                            });
                          }}
                          title={"Allocation Summary"}
                          isTitle={false}
                        />
                      )}
                    </div>
                    {
                      <>
                        {allocationArray && selectedTab.id === 0 && (
                          <SummaryStatusBar dataSeries={allocationArray} />
                        )}
                        <AccordionTable
                          page={"normal"}
                          tab={selectedTab.id}
                          isOffshore={isOffshore}
                          dataPoint={dataPoint}
                          tableCaption={"Allocation Summary"}
                          isAccordionContentTableCaption={true}
                          AccordionContentTableCaptionSuffix={"Asset Class Sub"}
                        />
                      </>
                    }
                  </>
                ) : (
                  <NoDataFinancialAssets
                    className={"allocationTableOnly"}
                    image={portfolio}
                    alternateText={"No Financial Assets"}
                    message={noDataMessage}
                  />
                )}
              </div>

              <QuickViews />
            </div>
          ) : (
            <NoDataFinancialAssets
              className={""}
              image={portfolio}
              alternateText={"No Financial Assets"}
              message={noDataMessage}
            />
          )}

          {/* <PdfTable
            headerName={getReportHeader()}
            id={pdfTableId}
            data={excelPdfData || []}
            columns={pdfTableColumns}
            ref={pdfTableRef}
          /> */}
        </div>
      </>
    );
  },
);

export default FinancialAssetSummary;
